import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { PropTypes } from 'prop-types';
import React from 'react';

import { getFormattedDate } from '../../../utils';
import Link from '../../Link';

const CardImageBasedSideImage = ({ date: _date, image, slug, title }) => {
  const date = getFormattedDate(_date);

  return (
    <Link
      className="flex pr-6 border-r lg:pr-0 sm:pr-8 lg:pb-6 lg:border-b lg:border-r-0 border-smoke "
      to={`/article/${slug}/`}
    >
      <div className="flex-1">
        <h5 className="stink-h5 text-hover">{title}</h5>
        {date && <p className="mt-2 stink-footnote text-slate">{date}</p>}
      </div>
      <GatsbyImage
        alt={title}
        className="lg:w-16 lg:h-full lg:ml-12 image-hover"
        image={getImage(image)}
      />
    </Link>
  );
};

CardImageBasedSideImage.propTypes = {
  date: PropTypes.string,
  image: PropTypes.object,
  slug: PropTypes.string,
  title: PropTypes.string,
};

export default CardImageBasedSideImage;
